// hooks
import { useStore } from '@/store';
import { useAxios } from '@/vue3/hooks/axiosHook';

export const useGeoRecordStatusService = () => {
    // hooks
    const { apiUrl } = useStore().state;
    const axios = useAxios();

    const getAllGeoRecordStatus = async (): Promise<any[]> => {
        const res = await axios.get(`${apiUrl}/geo-record-status`);
        return res.data;
    };

    return {
        getAllGeoRecordStatus,
    };
};
